import { Component, Event, EventEmitter, Fragment, JSX, Prop, State, h } from '@stencil/core'

import { FilterGroup } from './air-filter-groups.types'
import { isMobile } from '../../utils/matchMedia'
import { windowProvider } from '../../utils/windowProvider'

@Component({
  tag: 'air-filter-groups',
  styleUrl: 'air-filter-groups.scss',
  shadow: true,
})
export class AirFilterGroups {
  /** Specifies filter groups header text */
  @Prop() header?: string

  /** Specifies filter groups */
  @Prop() groups: FilterGroup[] = []

  /** Emits when filter groups were changed (e.g. one of checkboxes checked/unchecked) */
  @Event({ eventName: 'air-update' }) update!: EventEmitter<FilterGroup[]>

  @State() isMobile = false
  @State() isModalOpen = false

  componentWillLoad(): void {
    windowProvider().addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  disconnectedCallback(): void {
    windowProvider().removeEventListener('resize', this.handleResize)
  }

  private handleResize = (): void => {
    this.isMobile = isMobile()
  }

  private handleMobileTriggerClick = (): void => {
    this.isModalOpen = !this.isModalOpen
  }

  private handleUpdate = (): void => {
    this.update.emit(this.groups)
    this.handleModalClose()
  }

  private handleModalClose = (): void => {
    this.isModalOpen = false
  }

  private renderGroups(): HTMLAirFilterElement[] {
    return this.groups.map((group) => {
      return <air-filter class="group" {...group}></air-filter>
    })
  }

  private renderButton(): HTMLAirButtonElement {
    return (
      <air-button class="update-button" onClick={this.handleUpdate}>
        Update Results
      </air-button>
    )
  }

  private renderContent(): HTMLElement {
    return (
      <Fragment>
        <header class="header-text">{this.header}</header>
        {this.renderGroups()}
        {this.renderButton()}
      </Fragment>
    )
  }

  render(): JSX.Element {
    return (
      <div class="filter-groups">
        {this.isMobile ? (
          <div class="mobile">
            <air-button variant="secondary" onClick={this.handleMobileTriggerClick}>
              {this.header}
            </air-button>
            <air-modal opened={this.isModalOpen} onAir-close={this.handleModalClose} dismissible>
              <header slot="header" class="header-text">
                {this.header}
              </header>
              {this.renderGroups()}
              <div slot="footer">{this.renderButton()}</div>
            </air-modal>
          </div>
        ) : (
          this.renderContent()
        )}
      </div>
    )
  }
}
